/**
 * Registry-based proxy for the recursive `TypeEditor`.
 *
 * `editors.jsx` and `TypeEditor.jsx` form a natural recursion cycle
 * (column/vertical-layout editors render a nested `TypeEditor` of an arbitrary
 * child element). To break the ES-module import cycle without restructuring
 * the whole editor tree, we:
 *
 *   1. Have `TypeEditor.jsx` import its building-block editors from
 *      `./editors` (one-way).
 *   2. Have `editors.jsx` import the `TypeEditor` proxy from this registry
 *      (also one-way, since this file imports nothing from either side).
 *   3. `TypeEditor.jsx` calls `registerTypeEditor(TypeEditor)` at module load,
 *      so the proxy resolves to the real component at render time.
 */
import { createElement } from "react";

let _TypeEditor = null;

export function registerTypeEditor(component) {
  _TypeEditor = component;
}

export function TypeEditor(props) {
  if (!_TypeEditor) return null;
  return createElement(_TypeEditor, props);
}
